export default __webpack_public_path__ + "static/media/careWhiteHollow.eb25edf7.svg";